import React from 'react'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'
import { AddressCard, ItemCard, TOAST_TYPE } from '@base'
import { DRAWER_TYPES, strings } from '@constants'
import { Headings } from '.'
import { Spacings, Text } from '@styles'
import { Edit } from '@material-ui/icons'
import { toggleDrawer } from '@data/state/action/root'
import { addAddressToOrganisation, updateInvoiceV2 } from '@data'
import { showToast } from '@data/state/action'

const SectionBody = styled.div`
	display: flex;
	flex-direction: column;
`
const AddressCardWrapper = styled.div`
	display: flex;
	gap: ${Spacings.SPACING_2B};
	&:nth-child(1) > div {
		width: 100%;
	}
`
const DispatchLocationWapper = styled.div`
	display: flex;
	align-items: center;
	gap: ${Spacings.SPACING_1B};
	cursor: pointer;
	& > svg {
		font-size: ${Text.LARGE};
	}
`

const FrieghttigerTrip = ({ invoiceData, order, setOpen, update }) => {
	const dispatch = useDispatch()
	let dispatchLocation = ''
	let dispatchUser = ''
	let matchedInvoice = ''
	let shippingAddress = order?.buyer_list[0]?.shipping_address
	for (const supplier of order?.supplier_list || []) {
		dispatchLocation = supplier?.dispatch_location
		matchedInvoice = supplier?.supplier_invoices?.find((inv) => inv?.original_invoice_number === invoiceData?.vendor_bill_no?.[0])
		if (matchedInvoice) {
			dispatchUser = supplier?.supplier
			dispatchLocation = matchedInvoice?.dispatch_location || dispatchLocation
			break
		}
	}

	const ItemData = [
		{
			label: strings(['invoice', 'number']),
			value: invoiceData?.original_invoice_number ? invoiceData?.original_invoice_number : invoiceData?.invoice_number,
		},
		{
			label: strings(['bill', 'number']),
			value: invoiceData?.vendor_bill_no ? invoiceData?.vendor_bill_no : '-',
		},
		{
			label: strings(['driver', 'number']),
			value: invoiceData?.driver_number ? invoiceData?.driver_number : '-',
		},
		{
			label: strings(['vehicle', 'number']),
			value: invoiceData?.vehicle_number ? invoiceData?.vehicle_number : '-',
		},
	]

	const addNewAddress = (_dispatchlocation) => {
		addAddressToOrganisation(_dispatchlocation, dispatchUser?.organisation_id)
			.then((res) => {
				updateAddress(res)
				dispatch(showToast(true, 'Successfully added a new address', { type: TOAST_TYPE.SUCCESS }))
			})
			.catch((err) => {
				let error_msg = 'Error while adding a new address'
				if (err?.response?.data?.client_error_code === 'E_002') {
					error_msg = err?.response?.data?.message
				}
				dispatch(showToast(true, error_msg, { type: TOAST_TYPE.ERROR }))
			})
	}

	const updateAddress = (updatedLocation) => {
		let updatedInvoiceData
		updateInvoiceV2({ ...matchedInvoice, dispatch_location: updatedLocation }, order?.order_id)
			.then((res) => {
				update()
				dispatch(showToast(true, 'Address updated successfully', { type: TOAST_TYPE.SUCCESS }))
				updatedInvoiceData = res.data?.buyer_list[0].buyer_invoices.find((_i) => _i.invoice_number === invoiceData.invoice_number)
				dispatch(
					toggleDrawer(true, DRAWER_TYPES.ADMIN_EDIT_ORDER_INVOICE, {
						invoiceData: updatedInvoiceData,
						order: res.data,
						update,
						TripOpen: true,
					})
				)
			})
			.catch((error) => {
				console.log(error?.response?.message)
				dispatch(showToast(true, 'Address not updated', { type: TOAST_TYPE.ERROR }))
			})
			.finally(() => {
				setOpen(true)
			})
	}
	return (
		<>
			<ItemCard small clickable={false} data={ItemData} invoiceData={true} />
			<SectionBody>
				<AddressCardWrapper>
					<div>
						<Headings
							onClick={() => {
								dispatch(
									toggleDrawer(true, DRAWER_TYPES.UPDATE_DISPATCH_ADDRESS, {
										addToNewEnquiry: true,
										addNewAddress,
										updateAddress,
										label: 'Update Dispatch Address',
										user: dispatchUser,
									})
								)
							}}
						>
							<DispatchLocationWapper>
								{strings('dispatch', 'from')}
								{invoiceData?.vendor_bill_no?.[0] && <Edit />}
							</DispatchLocationWapper>
						</Headings>
						<AddressCard data={dispatchLocation} />
					</div>
					<div>
						<Headings>{strings('ship', 'to')}</Headings>
						<AddressCard data={shippingAddress} />
					</div>
				</AddressCardWrapper>
			</SectionBody>
		</>
	)
}

export default FrieghttigerTrip
